import React from "react";
import ModalNew from "./Modal";
import PopupHeader from "./common/popupHeader";
import AddressSuggestionPreview from "../../../utils/forms/address/AddressSuggestionPreview";

function AddressValidationModal({
  open,
  onClose,
  userAddress,
  suggestedAddress,
  onAccept,
  title = "Confirm Address",
}) {
  if (!open) return null;
  return (
    <ModalNew>
      <PopupHeader title={title} setOpenState={onClose} />
      {suggestedAddress ? (
        <AddressSuggestionPreview
          userAddress={userAddress}
          suggestedAddress={suggestedAddress}
          handleSelect={(choice) => onAccept && onAccept(choice)}
        />
      ) : (
        <div style={{ padding: 30, textAlign: "center" }}>
          <p>Validating address...</p>
        </div>
      )}
    </ModalNew>
  );
}

export default AddressValidationModal;
